// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_kgNL4fCz","container":"_xHQ20nMN","title":"_wpH2FLGw","image":"_POCiIWP_"};